import React from 'react';
import { Button, Grid, InputAdornment, MenuItem, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { FIELD_CONFIGS, OPTIONAL_EMPTY_COLOR, REQUIRED_EMPTY_COLOR } from './constants';

const SelectionFormGrid = ({
  formValues,
  errors,
  onFieldChange,
  onDateChange,
  onUnmatchReferenceId,
}) => {
  const getBackgroundColor = (field, value) => {
    if (value && String(value).trim().length > 0) return undefined;
    return field.required ? REQUIRED_EMPTY_COLOR : OPTIONAL_EMPTY_COLOR;
  };

  return (
    <Grid container spacing={2}>
      {FIELD_CONFIGS.map((field) => {
        const value = formValues[field.name] ?? '';
        const backgroundColor = getBackgroundColor(field, value);
        const commonProps = {
          fullWidth: true,
          size: 'small',
          required: field.required,
          helperText: errors[field.name] || ' ',
          error: Boolean(errors[field.name]),
          InputProps: backgroundColor ? { sx: { backgroundColor } } : undefined,
        };

        if (field.type === 'date') {
          const dateValue = value ? dayjs(value, 'MM/DD/YY') : null;
          return (
            <Grid item xs={12} md={6} key={field.name}>
              <DatePicker
                label={field.label}
                value={dateValue}
                format="MM/DD/YY"
                onChange={(dayValue) => onDateChange(field.name, dayValue)}
                slotProps={{
                  actionBar: { actions: ['today'] },
                  textField: commonProps,
                }}
              />
            </Grid>
          );
        }

        if (field.type === 'select') {
          const options = field.options || [];
          return (
            <Grid item xs={12} md={6} key={field.name}>
              <TextField
                select
                label={field.label}
                value={value}
                onChange={(event) => onFieldChange(field.name, event.target.value)}
                {...commonProps}
              >
                {options.map((option) => {
                  if (typeof option === 'string') {
                    return (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    );
                  }
                  return (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          );
        }

        return (
          <Grid item xs={12} md={6} key={field.name}>
            <TextField
              label={field.label}
              value={value}
              onChange={(event) => onFieldChange(field.name, event.target.value)}
              {...commonProps}
              InputProps={
                field.name === 'referenceId'
                  ? {
                      ...commonProps.InputProps,
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            variant="text"
                            size="small"
                            onClick={onUnmatchReferenceId}
                            sx={{ textTransform: 'none', minWidth: 'auto', px: 0.5 }}
                          >
                            Unmatch
                          </Button>
                        </InputAdornment>
                      ),
                    }
                  : commonProps.InputProps
              }
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SelectionFormGrid;
